function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Bridges to Learning Foundation</h4>
            <p>
              A Texas 501(c)(3) nonprofit organization empowering underserved students
              in Dallas and rural Nepal through educational resources and STEM programs.
            </p>
            <div className="social-links">
              <a href="#!" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="#!" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#!" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="#!" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#programs">Programs</a></li>
              <li><a href="#impact">Impact</a></li>
              <li><a href="#story">Our Story</a></li>
              <li><a href="#get-involved">Get Involved</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Programs</h4>
            <ul>
              <li><a href="#programs">Dallas Back-to-School Initiative</a></li>
              <li><a href="#programs">Nepal Rural STEM Program</a></li>
              <li><a href="#programs">Cross-Cultural Exchange</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li><i className="fas fa-envelope"></i> <a href="mailto:contact@joinbtlf.org">contact@joinbtlf.org</a></li>
              <li><i className="fas fa-map-marker-alt"></i> Dallas-Fort Worth, Texas</li>
              <li><i className="fas fa-globe"></i> Ilam District, Nepal</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Bridges to Learning Foundation, Inc. All rights reserved.</p>
          <p>Tax ID (EIN): 42-2806097</p>
          <p className="tagline">&#127753; Connecting Communities, Building Futures</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
